import {Flex,  SVGButton, Hint, SlideInput, ToogleInput, CheckboxInput} from '/app/src/component'
import DateTime from '/app/src/lib/DateTime'
import style from './style.css'
import React from 'react'


const SchedulerContainerStyle = (selected) => ({
    className: style.LargeContainerStyle,
    dataName: 'SchedulerContainer',
    border: selected ? '3px solid #2ea2d2': '3px solid transparent',
    hoverBorder: selected? '3px solid #2ea2d2' : '3px solid #f0f0f0',
    hAlignContent: 'center', shrink: 0
})

const AddNewTimeButtonStyle = {
    marginLeft: 'auto', marginTop: '40px',
    fontSize: '46px', width: '50px',
    height: '50px', color: 'darkgrey',
    backgroundColor: 'darkwhite', backgroundHover: 'lightgrey',
    borderRadius: '10px !important'
}
const RemoveTimeButtonStyle = {
    src:'/images/Trash.svg', color:'darkgrey',
    hover:'red', size:'medium'
}

const formatLabel = (value) => {
    let time = DateTime.convertMinutesToHour(value)
    time = time.map((value) => {
        if(value < 10){
            return '0' + value.toString()
        }
        return value.toString()
    })
    time = time.join(':')
    return time
}


export default ({current, index, onSelected,
    offlineConditions, setOfflineConditions,
    offlineSmartConditionOn, setOfflineSmartConditionOn
}) => {
    const isSelected = current === index

    const OfflineSmartRadioButtonOnClick = () => {
        setOfflineSmartConditionOn(!offlineSmartConditionOn)
    }

    const renderTimeTrigger = () => {
        const updateTimeInterval = (index) => {
            return (value) => {
                // If the user slides the slider to the end the SlideInput component will output 24:00 (1440 minutes) despite 
                // its maximum being set to 23:59 (1439 minutes). To prevent this we simply handle this edge case with an if-statement.
                if(value.max == 1440){ 
                    value.max = 1439;
                }

                offlineConditions[0]['message']['condition']['time'][index]['time_before'] = DateTime.convertMinutesToHour(value.min)
                offlineConditions[0]['message']['condition']['time'][index]['time_after'] = DateTime.convertMinutesToHour(value.max)
                setOfflineConditions(offlineConditions)
            }
        }
        const addNewTime = () => {
            offlineConditions[0]['message']['condition']['time'].push(
                {'time_before': [9,0], 'time_after':[17,0]}
            )
            setOfflineConditions(offlineConditions)
        }
        const removeTime = (index) => {
            return () => {
                offlineConditions[0]['message']['condition']['time'].splice(index, 1)
                setOfflineConditions(offlineConditions)
            }
        }

        let times = offlineConditions[0]['message']['condition']['time']
        let timeComponents = [];
        times.forEach((time, index) => {
            let minValue = time.time_before[0]*60 + time.time_before[1]
            let maxValue = time.time_after[0]*60 + time.time_after[1]
            timeComponents.push(
                <Flex shrink={0} marginTop='50px' key={index}>
                    <SlideInput
                        formatLabel={formatLabel}
                        minValue={0} maxValue={1439} step={5}
                        value={{min: minValue, max: maxValue}}
                        onChange={updateTimeInterval(index)}
                    />
                    <Flex width='50px' paddingLeft='20px'>
                {times.length > 1 && (
                    <SVGButton key='timeRemove' onClick ={removeTime(index)} {...RemoveTimeButtonStyle}/>
                )}
                    </Flex>
                </Flex>
            )
        })
        timeComponents.push(
            <SVGButton key='timeAddition' text='+' onClick={addNewTime} {...AddNewTimeButtonStyle} />
        )
        return timeComponents
    }
    const renderWeekDays = () => {
        let active = [0,1,2,3,4]
        if(offlineConditions.length){
            active = offlineConditions[0]['message']['condition']['days_of_the_week']
        }
        return (
            <ToogleInput
                values={[ {value: 0, label: 'Må'}, {value: 1, label: 'Ti'},
                          {value: 2, label: 'On'}, {value: 3, label: 'To'},
                          {value: 4, label: 'Fr'}, {value: 5, label: 'Lö'},
                          {value: 6, label: 'Sö'}
                ]}
                active={active}
                onChange={(event)=> {
                    offlineConditions[0]['message']['condition']['days_of_the_week'] = event.target.value
                    setOfflineConditions(offlineConditions)
                }}
                name='weekDays'
            />
        )
    }
    return (
        <Flex onClick={onSelected(index)} {...SchedulerContainerStyle(isSelected)}>
            <Flex column grow>
                <Flex
                    color='black'
                    fontSize='24px'
                    fontWeight={isSelected?'500':'300'} >
                Schemalägg öppettider <Hint position='right' tooltip='Tips: Om ni lagt in automeddelanden, se till att schemat passar ihop med dessa.'/>
                </Flex>
                <Flex color='black' fontSize='18px' my='8px' mb='20px'>
                    Ställ in under vilka tider chatten ska vara öppen. All övrig tid visas offlineformulär.
                </Flex>

                <Flex mt='5px' shrink={0} >
                    <Flex w='30px' mt='5px' onClick={OfflineSmartRadioButtonOnClick}>
                        <CheckboxInput checked={offlineSmartConditionOn}/>
                    </Flex>
                    <Flex mt='5px' ml='7px' fontSize='24px' fontWeight='300' userSelect='none'>
                        Auto inom schema <Hint position='right' tooltip='Chatten går endast online när en medarbetare loggar in under de satta öppettiderna. All övrig tid visas offlineformuläret, även om en medarbetare loggar in utanför öppettiderna.'/>
                    </Flex>
                </Flex>

                <Flex mt='15px' mb='5px' fontSize='18px' color='black'>
                    Veckodagar
                </Flex>
                    {renderWeekDays()}
                <Flex mt='15px' mb='5px' fontSize='18px' color='black'>
                    Tidsintervaller
                </Flex>
                    {renderTimeTrigger()}
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/OfflineSettings/_SchedulingOption.js